import { hotRank } from "@/mocks/homeData";

export default function Rank() {
  const maxHeat = hotRank[0]?.heat ?? 1;
  return (
    <section id="rank" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-sm font-medium tracking-wide text-primary-600">热门瓜榜 · HOT RANK</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">今日热门瓜榜</h2>
          </div>
          <span className="hidden items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-medium text-secondary-800 sm:inline-flex">
            <i className="ri-time-line" aria-hidden="true"></i>每 30 分钟更新
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {hotRank.map((r) => {
            const medal = r.rank === 1 ? "text-accent-500" : r.rank === 2 ? "text-foreground-500" : r.rank === 3 ? "text-primary-700" : "text-foreground-400";
            return (
              <article
                key={r.rank}
                className="group flex items-center gap-4 rounded-2xl border border-background-200/70 bg-background-100 p-4 transition-colors hover:border-primary-200"
              >
                <span className={`font-display text-3xl leading-none ${medal}`}>{r.rank}</span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="line-clamp-2 text-sm font-medium leading-6 text-foreground-900 group-hover:text-primary-800 md:text-base">
                      {r.title}
                    </h3>
                    <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium whitespace-nowrap text-secondary-800">
                      {r.cat}
                    </span>
                  </div>
                  <div className="mt-3 flex items-center gap-3">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-600"
                        style={{ width: `${(r.heat / maxHeat) * 100}%` }}
                      ></div>
                    </div>
                    <span className={`text-xs font-semibold whitespace-nowrap ${r.isUp ? "text-primary-700" : "text-foreground-500"}`}>
                      {r.isUp ? <i className="ri-arrow-up-line" aria-hidden="true"></i> : <i className="ri-arrow-down-line" aria-hidden="true"></i>}
                      {r.heat} 万
                    </span>
                  </div>
                  <p className="mt-1 text-[11px] text-foreground-500">{r.delta}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}